import {
  uploadFileToOss,
  type FetchOssUploadCredential,
  type OssUploadCredential,
  type OssUploadCredentialRequest,
} from 'fin-web-components';
import { post } from '../utils/backend';
import { APP_OSS_UPLOAD_CONFIG, getAppOssUploadPath, type AppOssUploadScene } from './OssConfig';

export const fetchAppOssUploadCredential: FetchOssUploadCredential = async (req) => {
  const result = await post<OssUploadCredentialRequest, OssUploadCredential>(
    '/lark/app/oss/getUploadCredential',
    req,
  );
  if (typeof result === 'string') {
    throw new Error(result);
  }
  if (!result) {
    throw new Error('获取上传凭证失败');
  }
  return result;
};

export async function uploadAppFileToOss(file: File, scene: AppOssUploadScene): Promise<string> {
  return uploadFileToOss(file, getAppOssUploadPath(scene), APP_OSS_UPLOAD_CONFIG, fetchAppOssUploadCredential);
}
